import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import TrackedPrompt from '../../prompts/TrackedPrompt';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { getFormattedContactName } from '../../contacts/operators/contactGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DisassociateModal({
  contact,
  onReject,
  onConfirm
}) {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(H2, {
        inlineSize: "100%",
        overflowWrap: "break-word",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.title",
          options: {
            name: getFormattedContactName(contact)
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {}), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "danger",
        onClick: onConfirm,
        "data-test-id": "disassociate-modal-confirm",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.save"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.cancel"
        })
      })]
    })]
  });
}
DisassociateModal.displayName = 'DisassociateModal';
export default TrackedPrompt({
  promptName: 'disassociate-contact-prompt'
})(DisassociateModal);